import * as React from 'react';

import { Typography } from 'omakase';
import { consumer } from '@tock/coretypes';
import AssociatedBusiness from 'components/business/landing-page/AssociatedBusiness';
import clsx from 'clsx';

interface Props {
  businesses: consumer.IRelatedBusiness[];
  columns?: 2 | 3;
}

export const AssociatedBusinesses: React.FunctionComponent<Props> = ({
  businesses = [],
  columns,
}) => {
  if (businesses.length === 0) {
    return null;
  }

  return (
    <div className="AssociatedBusinesses">
      <Typography component="h3" variant="heading02" mb={2}>
        Partners
      </Typography>

      <ul
        className={clsx('AssociatedBusinesses-list', {
          'AssociatedBusinesses-list--two-col': columns === 2,
        })}
      >
        {businesses.map((business) => {
          const associatedBusiness = business as consumer.RelatedBusiness;
          return (
            <li key={associatedBusiness.domainName} className="AssociatedBusinesses-listItem">
              <AssociatedBusiness business={associatedBusiness} />
            </li>
          );
        })}
      </ul>
    </div>
  );
};
